"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var trimDescription = function (description) {
    var desc = description ? description.split(' ') : '';
    if (desc.length >= 30) {
        var finalDescription = '';
        for (var i = 0; i <= 30; i++) {
            if (i === 30) {
                finalDescription += desc[i];
            }
            else {
                finalDescription += desc[i] + ' ';
            }
        }
        finalDescription += '...';
        return finalDescription;
    }
    return description;
};
exports.trimDescription = trimDescription;
var updateWidgetBrandColors = function (colors) {
    for (var key in colors)
        document.documentElement.style.setProperty('--' + key.replace('_', '-'), colors[key]);
};
exports.updateWidgetBrandColors = updateWidgetBrandColors;
var isLocalStorageAvailable = function () {
    try {
        var valueToStore = 'test';
        var mykey = 'key';
        localStorage.setItem(mykey, valueToStore);
        var recoveredValue = localStorage.getItem(mykey);
        localStorage.removeItem(mykey);
        return recoveredValue === valueToStore;
    }
    catch (e) {
        return false;
    }
};
exports.isLocalStorageAvailable = isLocalStorageAvailable;
var addChangelogToViewed = function (changelogID) {
    if (isLocalStorageAvailable()) {
        var storageKey = createHashFromString(location.origin + location.pathname + "-hn-changelog");
        var changelogs = localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : [];
        var index = changelogs.findIndex(function (changelog) { return changelog === changelogID; });
        if (index === -1) {
            changelogs.push(changelogID);
            localStorage.setItem(storageKey, JSON.stringify(changelogs));
        }
    }
};
exports.addChangelogToViewed = addChangelogToViewed;
var checkIfChangelogViewed = function (changelogID) {
    if (isLocalStorageAvailable()) {
        var storageKey = createHashFromString(location.origin + location.pathname + "-hn-changelog");
        var changelogs = localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : [];
        return changelogs.includes(changelogID);
    }
    return false;
};
exports.checkIfChangelogViewed = checkIfChangelogViewed;
var arraysEqual = function (arr1, arr2) {
    var a = arr1.sort(function (a, b) { return a - b; });
    var b = arr2.sort(function (a, b) { return a - b; });
    if (a === b)
        return true;
    if (a === null || b === null)
        return false;
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; ++i) {
        if (parseInt(a[i]) !== parseInt(b[i]))
            return false;
    }
    return true;
};
var createHashFromString = function (url) {
    var hash;
    for (var i = 0; i < url.length; i++) {
        hash = (hash << 5) - hash + url.charCodeAt(i);
        hash = hash & hash;
    }
    return hash;
};
exports.createHashFromString = createHashFromString;
var checkIfAllChangelogsViewed = function (changelogData) {
    if (isLocalStorageAvailable()) {
        var storageKey = createHashFromString(location.origin + location.pathname + "-hn-changelog");
        var changelogs = localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : [];
        return arraysEqual(changelogs, changelogData);
    }
    return false;
};
exports.checkIfAllChangelogsViewed = checkIfAllChangelogsViewed;
